function getProductJson(o) {
  return JSON.parse(
    document.querySelector(`.loopProductQuickJson-${o}`).textContent
  );
}

function getLoopSubscriptionContainer(o) {
  let e = getProductJson(o);
  return document.querySelector(`#loop-subscription-container-${o || e.id}`);
}

function findSelectedVariantLoop(o) {
  let e = null,
    l = {};
  if (
    ((l =
      window.loopProps && window.loopProps[o] && window.loopProps[o].product
        ? window.loopProps[o].product
        : getProductJson(o)),
    e || (e = window.loopProps[o].selectedVariantId),
    !e)
  ) {
    const { variants: o } = l;
    o && Array.isArray(o) && o.length && (e = o[0].id);
  }
  return l.variants && l.variants.find((o) => Number(o.id) === Number(e));
}

function defaultSelectFirstSellingPlanLoop(o, e) {
  let l = !0;
  (
    getLoopSubscriptionContainer(e).querySelectorAll(
      "input[name=loop_purchase_option]"
    ) || []
  ).forEach((e) => {
    Number(e.dataset.variantId) === Number(o.id) &&
      l &&
      ((l = !1),
      (e.checked = !0),
      setTimeout(function () {
        e.click();
      }, 300));
  });
}

function applySettings({ productId: o }) {
  let e = window.loopProps[o].product;
  const l = findSelectedVariantLoop(o);
  if (
    window &&
    window.loopPropsUI &&
    !1 === window.loopPropsUI.displayLoopPurchaseOptionLabel
  ) {
    let e = getLoopSubscriptionContainer(o).querySelectorAll(
      ".loop-purchase-options-label"
    );
    e &&
      e.forEach((o) => {
        o && o.classList.add("loop-display-none");
      });
  }
  if (
    window &&
    window.loopPropsUI &&
    window.loopPropsUI.loopPurchaseOptionslabel
  ) {
    let e = getLoopSubscriptionContainer(o).querySelectorAll(
      ".loop-purchase-options-label"
    );
    e &&
      e.forEach((o) => {
        o &&
          (o.innerHTML = `${
            window.loopPropsUI.loopPurchaseOptionslabel || "Purchase Options"
          }`);
      });
  }
  if (
    window &&
    window.loopPropsUI &&
    window.loopPropsUI.loopOneTimePurchaselabel
  ) {
    let e = getLoopSubscriptionContainer(o).querySelectorAll(
      ".loop-one-time-purchase-option-label"
    );
    e &&
      e.forEach((o) => {
        o &&
          (o.innerHTML = `${
            window.loopPropsUI.loopOneTimePurchaselabel || "One time Purchase"
          }`);
      });
  }
  if (
    window &&
    window.loopPropsUI &&
    window.loopPropsUI.displayOneTimePurchaseOptionAtBottom
  ) {
    let e = getLoopSubscriptionContainer(o).querySelector(
        "#loop-one-time-purchase-option-at-top"
      ),
      l = getLoopSubscriptionContainer(o).querySelector(
        "#loop-one-time-purchase-option-at-bottom"
      );
    e && l && e.innerHTML && ((l.innerHTML = e.innerHTML), (e.innerHTML = ""));
    let t = getLoopSubscriptionContainer(o).querySelectorAll(
      ".loop-subscription-group"
    );
    t &&
      t.forEach((o) => {
        o.classList.remove("loop-subscription-group-border-top"),
          o.classList.add("loop-subscription-group-border-bottom");
      });
    getLoopSubscriptionContainer(o)
      .querySelectorAll(".loop-one-time-purchase-option")
      .forEach((o) => {
        o.addEventListener("click", clickOnSellingPlanGroupContainer),
          o.addEventListener("click", addToCartPriceUpdate);
      });
    getLoopSubscriptionContainer(o)
      .querySelectorAll("input[name=loop_purchase_option]")
      .forEach((o) => {
        o.addEventListener("click", changeInSellingPlanGroupLoop),
          o.addEventListener("click", addToCartPriceUpdate);
      });
    document.querySelectorAll(".frequently-together-item").forEach((o) => {
      o.addEventListener("click", addToCartPriceUpdate);
    });
  }
  if (
    window &&
    window.loopPropsUI &&
    !1 === window.loopPropsUI.displayEachLabelForPrice
  ) {
    let o = document.querySelectorAll(
      ".loop-subscription-group-price-quantity"
    );
    o &&
      o.forEach((o) => {
        o.classList.add("loop-display-none");
      });
    let e = document.querySelectorAll(
      ".loop-one-time-purchase-option-price-quantity"
    );
    e &&
      e.forEach((o) => {
        o.classList.add("loop-display-none");
      });
  }
  if (
    window &&
    window.loopPropsUI &&
    window.loopPropsUI.hidePlanSelectorIfOnlyOne
  ) {
    const { availableSellingPlanAllocations: e = [] } = window.loopProps[o];
    let t = [];
    e.map((o) => {
      t.push(o.selling_plan_group_id);
    });
    let n = arrToInstanceCountObj(t);
    Object.keys(n).forEach((o) => {
      if (1 === n[o]) {
        let e = `#loop-selling-plan-container-${l.id}-${o}`,
          t = document.querySelector(e);
        if (t) {
          let e = t.querySelector(".loop-selling-plan-selector-label"),
            n = t.querySelector(
              `#loop-selling-plan-first-delivery-options-${l.id}-${o}`
            ),
            i = t.querySelector(".loop-selling-plan-selector");
          e && e.classList.add("loop-display-none"),
            n && n.classList.add("loop-display-none"),
            i && i.classList.add("loop-display-none");
        }
      }
    });
  }
  if (
    window &&
    window.loopPropsUI &&
    window.loopPropsUI.showPlanSelectorAsTextIfOnlyOnePlan &&
    !window.loopPropsUI.hidePlanSelectorIfOnlyOne
  ) {
    const { availableSellingPlanAllocations: e = [] } = window.loopProps[o];
    let t = [];
    e.map((o) => {
      t.push(o.selling_plan_group_id);
    });
    let n = arrToInstanceCountObj(t);
    Object.keys(n).forEach((o) => {
      if (1 === n[o]) {
        let e = `#loop-selling-plan-first-delivery-options-${l.id}-${o}`,
          t = document.querySelector(e);
        t && t.classList && t.classList.remove("loop-display-none"),
          (e = `#loop-select-${l.id}-${o}`),
          (t = document.querySelector(e)),
          t && t.classList.add("loop-display-none");
      }
    });
  }
  if (
    window &&
    window.loopPropsUI &&
    window.loopPropsUI.hideWholeWidgetIfOnlyOnePlan &&
    e.requires_selling_plan &&
    l.selling_plan_allocations &&
    1 === l.selling_plan_allocations.length
  ) {
    let e = getLoopSubscriptionContainer(o).querySelector(
      "#loop-selling-plan-fieldset"
    );
    e && e.classList.add("loop-display-none");
    let l = getLoopSubscriptionContainer(o).querySelectorAll(
      ".loop-purchase-options-label"
    );
    l &&
      l.forEach((o) => {
        o && o.classList.add("loop-display-none");
      });
  }
  if (
    window &&
    window.loopPropsUI &&
    window.loopPropsUI.hideRadioButtonIfOnlyOnePlan &&
    e.requires_selling_plan
  ) {
    const { availableSellingPlanAllocations: e } = window.loopProps[o];
    let l = [];
    e.map((o) => {
      l.push(o.selling_plan_group_id);
    });
    let t = arrToInstanceCountObj(l),
      n = !1;
    if (((n = 1 === Object.keys(t).length), n)) {
      let e = getLoopSubscriptionContainer(o).querySelectorAll(
        ".loop-subscription-group-radio"
      );
      e &&
        e.forEach((o) => {
          o.classList.add("loop-display-none");
        });
      let l = getLoopSubscriptionContainer(o).querySelectorAll(
        ".loop-subscription-group-selling-plans-container"
      );
      l &&
        l.forEach((o) => {
          o.classList.add("loop-left-margin-0");
        });
    }
  }
  if (window && window.loopPropsUI && window.loopPropsUI.style) {
    let o = {
      purchase_option_label: [".loop-purchase-options-label"],
      widget_feildset: [".loop-selling-plan-fieldset"],
      selling_plan_group_container: [
        ".loop-one-time-purchase-option",
        ".loop-subscription-group",
      ],
      selling_plan_group_label: [
        ".loop-one-time-purchase-option-label",
        ".loop-subscription-group-label",
      ],
      selling_plan_label: [".loop-selling-plan-selector-label"],
      selling_plan_selector: [".loop-selling-plan-selector"],
      selling_plan_price_label: [
        ".loop-one-time-purchase-option-price-amount",
        ".loop-subscription-group-price-amount",
      ],
      selling_plan_price_subtitle_label: [
        ".loop-one-time-purchase-option-price-quantity",
        ".loop-subscription-group-price-quantity",
      ],
      selling_plan_description_label: [
        ".loop-selling-plan-selector-description",
      ],
      selling_plan_discount_badge_style: [
        ".loop-subscription-group-discount-badge",
      ],
      subscription_details_label: [".loop-tooltip-label"],
      subscription_details_popup: [
        ".loop-tooltiptext",
        ".loop-container-arrow",
        ".loop-tooltip-description",
      ],
      selling_plan_group_selected: [".loop-selected-selling-plan-group"],
      selling_plan_group_radio: [
        ".loop-subscription-group-radio",
        ".loop-one-time-purchase-option-radio",
      ],
    };
    const e = ({ id: o, data: e }) => {
        if (e) {
          let o = Object.keys(e),
            l = "";
          return (
            o.forEach((o) => {
              let t = e[o];
              l = `${l} ${o}: ${t} !important;`;
            }),
            l
          );
        }
        return "";
      },
      l = ({ id: e, data: l }) => o[e] || [];
    let t = "";
    const { style: n } = window.loopPropsUI;
    n.map((o) => {
      l(o).map((l) => {
        t += `\n                 ${l} {\n                     ${e(
          o
        )}\n                 }\n             `;
      });
    });
    let i = document.querySelectorAll(".loop-style");
    i &&
      i.forEach((o) => {
        o.innerHTML = `${o.innerHTML}\n                 ${t}\n             `;
      });
  }
  if (window && window.loopPropsUI && window.loopPropsUI.cssClassess) {
    let o = document.querySelectorAll(".loop-style");
    o &&
      o.forEach((o) => {
        o.innerHTML = `${o.innerHTML}\n                 ${window.loopPropsUI.cssClassess}\n             `;
      });
  }
  if (
    window &&
    window.loopPropsUI &&
    window.loopPropsUI.displaySubscriptionPopup &&
    l &&
    l.selling_plan_allocations &&
    l.selling_plan_allocations.length
  ) {
    let e = getLoopSubscriptionContainer(o).querySelector("#loop-tooltip");
    if (e) {
      e.classList.remove("loop-display-none");
      let l = getLoopSubscriptionContainer(o).querySelector(
        "#loop-tooltip-label"
      );
      l && (l.innerHTML = window.loopPropsUI.subscriptionPopupLabel);
      let t = getLoopSubscriptionContainer(o).querySelector(
        "#loop-tooltip-description"
      );
      t && (t.innerHTML = window.loopPropsUI.subscriptionPopupDescription),
        l && t && (l.style.fill = window.getComputedStyle(t).color);
    }
  } else {
    let e = getLoopSubscriptionContainer(o).querySelector("#loop-tooltip");
    e && e.classList.add("loop-display-none");
  }
  if (
    e &&
    e.requires_selling_plan &&
    Array.isArray(l.selling_plan_allocations) &&
    l.selling_plan_allocations.length
  ) {
    let e = `#loop-product-variant-${l.id}`,
      t = getLoopSubscriptionContainer(o).querySelector(e);
    if (
      window &&
      window.loopPropsUI &&
      window.loopPropsUI.displayOneTimePurchaseOptionAtBottom
    ) {
      l.selling_plan_allocations[l.selling_plan_allocations.length - 1];
      let o = ".loop-subscription-group",
        e = t.querySelectorAll(o);
      if (e && e.length) {
        let o = e[e.length - 1];
        (o.style.borderBottom = "0"),
          o.classList.remove("loop-subscription-group-border-bottom");
      }
    } else {
      l.selling_plan_allocations[0];
      let o = ".loop-subscription-group",
        e = t.querySelectorAll(o);
      if (e && e.length) {
        let o = e[0];
        (o.style.borderTop = "0"),
          o.classList.remove("loop-subscription-group-border-top");
      }
    }
  }
  if (window && window.loopPropsUI && window.loopPropsUI.displayDiscountBadge)
    displayDiscountBadge({
      productId: o,
    });
  else {
    let o = document.querySelectorAll(
      ".loop-subscription-group-discount-badge"
    );
    o &&
      o.forEach((o) => {
        o && o.classList.add("loop-display-none");
      });
  }
  if (window && window.loopPropsUI && window.loopPropsUI.translationData) {
    let o = window.loopPropsUI.translationData || {},
      e = {
        widget_price_label_text: [
          ".loop-one-time-purchase-option-price-quantity",
          ".loop-subscription-group-price-quantity",
        ],
      };
    Object.keys(e).forEach((l) => {
      if (o && o[l]) {
        e[l].map((e) => {
          let t = document.querySelectorAll(e);
          t &&
            t.forEach((e) => {
              e.innerText = o[l];
            });
        });
      }
    });
  }
}

function clickOnSellingPlanGroupContainer(o) {
  let e = o.target.closest(".loop-subscription-group"),
    l = null;
  e || (e = o.target.closest(".loop-one-time-purchase-option")),
    (l = e.querySelector('input[type="radio"]')),
    l?.dataset?.id !==
      window.loopProps[l.dataset.productId].sellingPlanGroupId && l.click();
}

function variantChanged({ loopProduct: o, variantId: e }) {
  loopInit({
    productId: o.id,
    product: JSON.parse(JSON.stringify(o)),
    variantId: e,
  }),
    addToCartPriceUpdate(e);
}

function checkVariantsSellingPlanAllocation(o, e) {
  if (
    o &&
    Array.isArray(o.selling_plan_allocations) &&
    o.selling_plan_allocations.length
  ) {
    let o = getLoopSubscriptionContainer(e).querySelector(
      "#loop-selling-plan-fieldset"
    );
    o && o.classList.remove("loop-display-none-by-variant");
    let l = getLoopSubscriptionContainer(e).querySelectorAll(
      ".loop-purchase-options-label"
    );
    l &&
      l.forEach((o) => {
        o && o.classList.remove("loop-display-none-by-variant");
      });
  } else {
    let o = getLoopSubscriptionContainer(e).querySelector(
      "#loop-selling-plan-fieldset"
    );
    o && o.classList.add("loop-display-none-by-variant");
    let l = document.querySelectorAll(".loop-purchase-options-label");
    l &&
      l.forEach((o) => {
        o && o.classList.add("loop-display-none-by-variant");
      });
  }
}

function loopInit({ productId: o, product: e, variantId: l }) {
  updateLoopProperties({
    product: e,
    productId: o,
    variantId: l,
  });
  const t = findSelectedVariantLoop(o, l);
  let n = t.id;
  if (
    (e.variants.map((o) => {
      o.id == n
        ? (document.querySelector(
            `#loop-product-variant-${o.id}`
          ).style.display = "block")
        : (document.querySelector(
            `#loop-product-variant-${o.id}`
          ).style.display = "none");
    }),
    checkVariantsSellingPlanAllocation(t, o),
    window &&
      window.loopPropsUI &&
      window.loopPropsUI.byDefaultChooseSubscriptionOption)
  )
    defaultSelectFirstSellingPlanLoop(t, o);
  else {
    const e = getLoopSubscriptionContainer(o).querySelector(
      `#loop-one-time-purchase-${o}`
    );
    e ? ((e.checked = !0), e.click()) : defaultSelectFirstSellingPlanLoop(t, o);
  }
  applySettings({
    productId: o,
  });
  let i =
    $('[name="option"]').find(":selected").val() ||
    $('[name="size"]').find(":selected").val();
  void 0 === i &&
    ((i = $('.select-option [name="id"]').find(":selected").text()),
    console.log("undefined op_value " + i)),
    (i = i.replace(/\s/g, ""));
  let r,
    p = $(".quantity-right option:selected").attr("data-value") || 0;
  (r =
    0 != p
      ? $(
          '.sale-discount .sale-discount-onetime span[data-variant-title="' +
            i +
            "/" +
            p +
            '"]'
        ).attr("data-sale-discount")
      : $(
          '.sale-discount .sale-discount-onetime span[data-variant-title="' +
            i +
            '/"]'
        ).attr("data-sale-discount")),
    r
      ? document.querySelectorAll(".loop-onetime-description").forEach((o) => {
          (o.innerHTML = "Get Extra " + r + "% Off"),
            (o.style.display = "block");
        })
      : document.querySelectorAll(".loop-onetime-description").forEach((o) => {
          (o.innerHTML = ""), (o.style.display = "none");
        });
}

function updateSelectDropDownDefaultValues({
  productId: o,
  variant: e,
  sellingPlanGroupId: l,
}) {
  const { selling_plan_groups: t } = window.loopProps[o].product;
  t &&
    Array.isArray(t) &&
    t.length &&
    t.map((o) => {
      if (l !== o.id) {
        let l = document.getElementById(`loop-select-${e.id}-${o.id}`);
        l && (l.options[0].selected = !0);
      }
    });
}

function changeInSellingPlanGroupLoop(o) {
  let e = o.target.dataset.id,
    l = o.target.dataset.name,
    t = o.target.dataset.productId;
  const n = findSelectedVariantLoop(t, window.loopProps[t].selectedVariantId);
  let i =
      n.selling_plan_allocations.filter((o) => o.selling_plan_group_id === e) ||
      [],
    r = i && i.length ? i[0] : {},
    p = r.selling_plan_id;
  updateLoopProperties({
    productId: t,
    variantId: n.id,
    sellingPlanGroupId: e,
    sellingPlanGroupName: l,
    sellingPlanId: p,
    sellingPlan: r,
  }),
    updateSelectDropDownDefaultValues({
      productId: t,
      variant: n,
      sellingPlanGroupId: o.target.dataset.id,
    }),
    updatePriceInParentElements({
      productId: t,
    }),
    updateSellingPlanDescriptionUI({
      productId: t,
    }),
    displayDiscountBadge({
      productId: t,
    }),
    updatePriceInUI({
      productId: t,
    });
  let a = getLoopSubscriptionContainer(t).querySelectorAll(
    ".loop-selected-selling-plan-group"
  );
  if (
    (a &&
      a.forEach((o) => {
        o && o.classList.remove("loop-selected-selling-plan-group");
      }),
    "loop-one-time-purchase" === e)
  ) {
    let o = getLoopSubscriptionContainer(t).querySelectorAll(
      ".loop-one-time-purchase-option"
    );
    o &&
      o.forEach((o) => {
        o.classList.add("loop-selected-selling-plan-group");
      });
  } else {
    let o = `#loop-${n.id}-${e}`,
      l = getLoopSubscriptionContainer(t).querySelector(o);
    l && l.classList.add("loop-selected-selling-plan-group");
  }
}

function changeInDeliveryOptionLoop(o) {
  let e = o.target.value,
    l = o.target.dataset.productId;
  updateLoopProperties({
    productId: l,
    sellingPlanId: e,
  }),
    updatePriceInParentElements({
      productId: l,
    }),
    updateSellingPlanDescriptionUI({
      productId: l,
    }),
    displayDiscountBadge({
      productId: l,
    }),
    updatePriceInUI({
      productId: l,
    });
}

function addToCartPriceUpdate(o = void 0) {
  console.log("cartpriceupdate function called");
  let e = null,
    l = null,
    t = "start",
    n = document.querySelector(
      "input[name=loop_purchase_option]:checked"
    ).parentElement,
    i =
      parseInt(
        $('.quantity-right [name="size"]').find(":selected").attr("data-value")
      ) ||
      parseInt(
        $(".purchase-type[data-pack-text]").attr("size-for-individual-products")
      );

  if (
    document.querySelector("input[name=loop_purchase_option]:checked")
      .className == "loop-one-time-purchase-option-radio"
  ) {
    e = n.getElementsByClassName(
      "loop-one-time-purchase-option-price-amount"
    )[0].innerHTML;
    l = e.substring(0, 1);
    if (Number.isInteger(parseInt(l))) {
      e = e.substring(0, e.length - 1);
      l = e.trim().slice(-1);
      t = "end";
    } else {
      e = e.substring(1);
    }
    e = parseFloat(e) * i;
  } else {
    e = n.querySelector(".loop-subscription-group-price-amount").innerHTML;
    l = e.substring(0, 1);
    if (Number.isInteger(parseInt(l))) {
      l = e.trim().slice(-1);
      t = "end";
    }
    e = "selling_plan";
  }

  let r = 0;

  let onep =
    parseFloat(
      window.loopProps[window.productId].sellingPlan.compare_at_price
    ) / 100;
  let v;

  if (o && "object" != typeof o) {
    const e = getProductJson(window.productId);
    for (const l of e.variants) {
      if (l.id == o) {
        r = (l?.compare_at_price ?? 0) / 100;
        break;
      }
    }
  } else {
    const o = Object.values(window.loopProps)[0].variant;
    if (e === "selling_plan") {
      e = o.selling_plan_allocations[0].price / 100;
      e = parseFloat(e);
    }
    r = o?.compare_at_price ? o.compare_at_price / 100 : o?.price / 100;
  }

    /* Add on: shaker bottle */
   var selected_val =  $('#SingleOptionSelector_add_on option:selected').val();
  if(selected_val){
    var element = $("#SingleOptionSelector_add_on").find('option:selected'); 
    let o = element.attr("data-price"); 
    let t = element.attr("data-compare-price"); 
   // console.log("select option"+  o +" "+t);

    if (["â‚«", "â‚¡"].includes(l)) {
      o = o.replaceAll(".", "");
      t = t.replaceAll(".", "");
    }
    if (l === "R") {
      o = o.replaceAll(",", "");
      t = t.replaceAll(",", "");
    }

    o = parseFloat(o);
   // console.log("currency_code", l);
//console.log("check_price", o);
    t = parseFloat(t);

    if (t > 0) {
      e = parseFloat(e + o);
      r = parseFloat(r + t);
    } else {
      e = parseFloat(e + o);
    }

    if (t > 0) {
      onep = parseFloat(onep + o);
      r = parseFloat(r + t);
    } else {
      onep = parseFloat(onep + o);
    }
  //  console.log("compare price"+ t);
  }
 // });

  /* end code add on proetin shaker */
  
  $(".frequently-together-item input:checked").each(function () {
    let o = $(this).attr("data-price");
    let t = $(this).attr("data-compare-price");

    console.log("clicked");

    if (["â‚«", "â‚¡"].includes(l)) {
      o = o.replaceAll(".", "");
      t = t.replaceAll(".", "");
    }
    if (l === "R") {
      o = o.replaceAll(",", "");
      t = t.replaceAll(",", "");
    }

    o = parseFloat(o);
    console.log("currency_code", l);
    console.log("check_price", o);
    t = parseFloat(t);

    if (t > 0) {
      e = parseFloat(e + o);
      r = parseFloat(r + t);
    } else {
      e = parseFloat(e + o);
    }

    if (t > 0) {
      onep = parseFloat(onep + t); // before it was     onep = parseFloat(onep + o);
      r = parseFloat(r + t);
    } else {
      onep = parseFloat(onep + o);
    }
  });

  v = loopFormatMoney(onep * 100, true, false).match(/\d+\.\d+/);

  console.log("Updated one-time price:", onep);

  // Set the compare at price to the updated one-time price
  r = onep;

  console.log("Updated compare at price:", r);

  // Update the UI price
  if (document.querySelector("#uiPrice")) {
    document.querySelector("#uiPrice").innerHTML = `${l}${v ? v[0] : r}`;
    console.log("UI price updated to:", `${l}${v ? v[0] : r}`);
  } else {
    console.log("#uiPrice element not found");
  }
// code by vivek for top price //
  
  $(".subscribe_price").find(".price-item--sale").html(`${l}${e.toFixed(2)}`);
    $(".subscribe_price").find(".price-item--regular").html(`${l}${r}`);
  
  // end code by vivek for top price //
  
  // Update the final price display
  const salePriceElement = document
    .getElementById("final_price-1")
    .getElementsByClassName("price__sale")[0]
    .getElementsByClassName("price-item--sale")[0];
  const regularPriceElement = document
    .getElementById("final_price-1")
    .getElementsByClassName("price__sale")[0]
    .getElementsByClassName("price-item--regular")[0];

  if (salePriceElement && regularPriceElement) {
    if (e !== "selling_plan") {
      salePriceElement.innerHTML = `${l}${e.toFixed(2)}`;
      regularPriceElement.innerHTML = `${l}${r}`;
      console.log("Final price (sale) updated to:", `${l}${e.toFixed(2)}`);
      console.log("Final price (regular) updated to:", `${r}${l}`);
    } else {
      salePriceElement.innerHTML = `${e}${l}`;
      regularPriceElement.innerHTML = `${r}${l}`;
      console.log("Final price (sale) updated to:", `${e}${l}`);
      console.log("Final price (regular) updated to:", `${r}${l}`);
    }
  } else {
    console.log(
      "Price elements not found or condition not met for final price update"
    );
  }
}

function displayDiscountBadge({ productId: o }) {
  const e = findSelectedVariantLoop(o),
    { selling_plan_groups: l } = window.loopProps[o].product;
  window && window.loopProps && window.loopPropsUI.displayDiscountBadge
    ? l.map((l) => {
        const { selling_plans: t } = l;
        let n = [];
        t.map((o) => {
          const { price_adjustments: l } = o;
          let t = l.length ? l[0] : {};
          n.push({
            value: t.value,
            value_type: t.value_type,
            amount:
              "fixed_amount" === t.value_type
                ? t.value
                : (Number(e.price) * t.value) / 100,
          });
        });
        let i = n.reduce((o, e) => (o.amount > e.amount ? o : e)),
          r = `#loop-discount-badge-${e.id}-${l.id}`,
          p = getLoopSubscriptionContainer(o).querySelector(r);
        if (
          window.loopProps[o] &&
          l.id === window.loopProps[o].sellingPlanGroupId
        ) {
          i = (
            t.find((e) => e.id === Number(window.loopProps[o].sellingPlanId)) ||
            {}
          ).price_adjustments[0];
        }
        if (p) {
          let o = "";
          i && "fixed_amount" === i.value_type
            ? (o = loopFormatMoney(i.value, !0))
            : i && "percentage" === i.value_type && (o = `${i.value}%`);
          let e = (window?.loopPropsUI?.discountBadgeText || " ").replace(
            "{discount_value}",
            o
          );
          (p.innerHTML = `${e}`),
            i?.value || Number(i?.value)
              ? p.classList.remove("loop-display-none")
              : p.classList.add("loop-display-none");
        }
      })
    : l.map((o) => {
        let l = `#loop-discount-badge-${e.id}-${o.id}`,
          t = document.querySelector(l);
        t && t.classList.add("loop-display-none");
      });
}

function calculateCurrentSellingPlanLoop({
  productId: o,
  availableSellingPlanAllocations: e,
}) {
  let l = {};
  const { sellingPlanId: t } = window.loopProps[o];
  for (let n = 0; n < e.length; n++) {
    const i = e[n];
    i.selling_plan_group_id === window.loopProps[o].sellingPlanGroupId &&
      (t
        ? Number(i.selling_plan_id) === Number(t) && (l = i)
        : (l && l.selling_plan_id) || (l = i));
  }
  return l;
}

function updateLoopProperties({
  product: o,
  productId: e,
  variantId: l,
  sellingPlanGroupId: t,
  sellingPlanGroupName: n,
  sellingPlanId: i,
}) {
  let r = getLoopSubscriptionContainer(e).querySelector(
    "#loop-selling-plan-fieldset"
  );
  l &&
    (Number(l) !== Number(r.dataset.selectedVariantId) &&
      ((r.dataset.sellingPlanGroupId = ""),
      (r.dataset.sellingPlanGroupName = ""),
      (r.dataset.sellingPlanId = "")),
    (r.dataset.selectedVariantId = l)),
    t && (r.dataset.sellingPlanGroupId = t),
    n && (r.dataset.sellingPlanGroupName = n),
    o && (r.dataset.product = JSON.stringify(o)),
    i
      ? (r.dataset.sellingPlanId = i)
      : "loop-one-time-purchase" === t &&
        ((r.dataset.sellingPlanId = ""),
        (r.dataset.sellingPlan = {}),
        (r.dataset.sellingPlan = {})),
    window.loopProps ||
      ((window.loopProps = {}),
      (window.loopProps[e] = {
        product: o,
        productId: e,
      })),
    (window.loopProps[e] = {
      ...r.dataset,
      productId: e,
    }),
    r.dataset &&
      r.dataset.product &&
      (window.loopProps[e] = {
        ...window.loopProps[e],
        product: JSON.parse(window.loopProps[e].product),
      });
  let p = findSelectedVariantLoop(e),
    a =
      p && Array.isArray(p.selling_plan_allocations)
        ? p.selling_plan_allocations
        : [];
  (window.loopProps[e].availableSellingPlanAllocations = a),
    (window.loopProps[e].variant = p);
  let s = calculateCurrentSellingPlanLoop({
      availableSellingPlanAllocations: a,
      productId: e,
    }),
    c = s.selling_plan_id || "";
  window.loopProps[e].sellingPlan = s;
  let d = a.find((o) => {
    if (c && Number(o.selling_plan_id) === Number(c)) return !0;
  });
  window.loopProps[e].sellingPlanAllocation = d;
  const { selling_plan_groups: u } = window.loopProps[e].product;
  (window.loopProps[e].sellingPlanDefination = {}),
    (window.loopProps[e].sellingPlanPriceAdjustments = []),
    u &&
      Array.isArray(u) &&
      u.map((o) => {
        if (o.id === window.loopProps[e].sellingPlanGroupId) {
          const { selling_plans: l } = o;
          l.map((o) => {
            o.id === Number(window.loopProps[e].sellingPlanId) &&
              ((window.loopProps[e].sellingPlanDefination = o),
              (window.loopProps[e].sellingPlanPriceAdjustments =
                o.price_adjustments));
          });
        }
      });
  let g = getLoopSubscriptionContainer(e).querySelector(
    '[name="selling_plan"]'
  );
  g && (g.value = c);
}

function updateCartButtonText({ productId: o }) {
  let e = document.querySelector(`#product_form_${o}`) || document,
    l =
      !window.loopProps ||
      !window.loopProps[o] ||
      !window.loopProps[o].sellingPlanGroupId ||
      "loop-one-time-purchase" === window.loopProps[o].sellingPlanGroupId,
    t = null;
  [
    "button[type='submit'][name='add']",
    "button[type='button'][name='add']",
  ].map((o) => {
    t || (t = e.querySelector(o));
  }),
    t && t.firstElementChild
      ? (t.firstElementChild.innerHTML = l
          ? window?.loopPropsUI?.translationData
              ?.widget_add_to_cart_button_for_one_time_purchase || "Add to cart"
          : window?.loopPropsUI?.translationData
              ?.widget_add_to_cart_button_for_subscription ||
            "Add subscription to cart")
      : t &&
        (t.innerHTML = l
          ? window?.loopPropsUI?.translationData
              ?.widget_add_to_cart_button_for_one_time_purchase || "Add to cart"
          : window?.loopPropsUI?.translationData
              ?.widget_add_to_cart_button_for_subscription ||
            "Add subscription to cart");
}

function loopFormatMoney(o, e, each_price_flag = true) {
  let l = "",
    t = $(".quantity-right option:selected").attr("data-value");
  l =
    void 0 === t
      ? parseInt(
          $(".purchase-type[data-pack-text]").attr(
            "size-for-individual-products"
          )
        )
      : parseInt(t);
  let n = findSelectedVariantLoop(window.productId).price / l,
    i = $(".purchase-type[data-pack-text]").attr("data-number-of-serving");
  if (each_price_flag == true) o /= l;

  let r = document.querySelector("#loop-price-money-format").innerText,
    p = document.querySelector(
      "#loop-price-money_without_currency-format"
    ).innerText,
    a = "",
    s = "",
    c = "";
  if (r.includes("0.00"))
    (a = r.replace("0.00", (o / 100).toFixed(2))),
      (s = r.replace("0.00", (o / i / 100).toFixed(2))),
      (c = r.replace("0.00", (n / i / 100).toFixed(2)));
  else if (r.includes("0,00"))
    (a = r.replace("0,00", (o / 100).toFixed(2).replace(".", ","))),
      (s = r.replace("0,00", (o / i / 100).toFixed(2).replace(".", ","))),
      (c = r.replace("0,00", (n / i / 100).toFixed(2).replace(".", ",")));
  else if (r.includes("0")) {
    let e = Number(p.replace("0", o / 100)).toFixed(0),
      l = Number(p.replace("0", o / i / 100)).toFixed(0),
      t = Number(p.replace("0", n / i / 100)).toFixed(0);
    (a = r.replace("0", e)), (s = r.replace("0", l)), (c = r.replace("0", t));
  }
  console.log("loop-printing currency", r);
  (s = s.replace("each", "")), (c = c.replace("each", ""));
  let d = $(".purchase-type[data-pack-text]").attr("data-pack-text");

  return (
    o != n &&
      document.querySelectorAll(".loop-per-pack-selling-price").forEach((o) => {
        o.innerHTML = "<span>Only</span> " + s + " / " + d;
      }),
    document.querySelectorAll(".loop-per-pack-onetime-price").forEach((o) => {
      o.innerHTML = "<span>Only</span> " + c + " / " + d;
    }),
    e ? a.replace("each", "") : a
  );
}

function getSavedPriceLabel(o) {
  if (o && Array.isArray(o) && o.length) {
    let e = o[0];
    return "percentage" === e.value_type
      ? `Save ${e.value}%`
      : `Save ${loopFormatMoney(e.value, !0)}`;
  }
  return "";
}

function updateSellingPlanDescriptionUI({ productId: o }) {
/* commented by vivek for 15%off first order theme */
  /* const new_value = window.loopProps[productId].sellingPlanPriceAdjustments[1].value;
  if (new_value==0){
   $("#1pack_no_discount").hide(); 
  }
  else{
     $("#1pack_no_discount").show(); 
  }
    document.getElementById("discountToShow_below_btn_new").innerText= new_value+"%";
    */
  /* end commented by vivek for 15%off first order theme */
  
 /* let e = "",
    l = findSelectedVariantLoop(o);
 
  if (
    window.loopProps &&
    window.loopProps[o] &&
    window.loopProps[o].sellingPlanGroupId
  ) {
    const { description: t } = window.loopProps[o].sellingPlanDefination;
    e = t;
    let n = document.querySelector(
      `#loop-selling-plan-description-${l.id}-${window.loopProps[o].sellingPlanGroupId}`
    );
    n && (n.innerHTML = e || ""),
      !e && n
        ? n.classList.add("loop-display-none")
        : e && n.classList.remove("loop-display-none");
    var discountPercentage = n?.innerHTML.match(/\d+/);
    var newText = " " + discountPercentage + "% OFF FIRST ORDER";
    let DiscountLabel = document.querySelector("#discountToShow");
    DiscountLabel.innerText = newText;
     document.getElementById("discountToShow_below_btn").innerText= newText;
  } */
}

function updatePriceInParentElements({ productId: o }) {
  let e = findSelectedVariantLoop(o);
  if (
    window?.loopProps[o]?.product?.handle !==
    window.location.pathname.split("/")[
      window.location.pathname.split("/").length - 1
    ]
  )
    return;
  let l = 0,
    t = 0,
    n = 0,
    i = 0,
    r = !0,
    p = "";
  window && window.loopProps && window.loopProps[o].sellingPlanAllocation
    ? ((l = loopFormatMoney(
        window.loopProps[o].sellingPlanAllocation.price,
        !0
      )),
      (t = loopFormatMoney(
        window.loopProps[o].sellingPlanAllocation.compare_at_price,
        !0
      )),
      (r = !0),
      (n = loopFormatMoney(
        window.loopProps[o].sellingPlanAllocation.per_delivery_price,
        !0
      )),
      (i = 0),
      (p = getSavedPriceLabel(window.loopProps[o].sellingPlanPriceAdjustments)))
    : ((l = loopFormatMoney(e.price, !0)),
      (t = loopFormatMoney(e.compare_at_price)),
      (r = !1),
      (n = 0),
      (i = 0)),
    loopPriceSelectors.push(`.loop-product-${o}`),
    loopPriceSelectors.map((o) => {
      let e = null;
      (e = document.querySelector(o)), e && (e.innerHTML = `${l}`);
    });
}

function updatePriceInUI({ productId: o }) {
  let e = findSelectedVariantLoop(o, window.loopProps[o].selectedVariantId),
    l =
      (e &&
        Array.isArray(e.selling_plan_allocations) &&
        e.selling_plan_allocations,
      document.querySelector("#loop-price-money-format").innerHTML,
      window.loopProps && window.loopProps[o]
        ? window.loopProps[o].sellingPlan
        : {});
  const t = window.loopProps[o]?.product || {},
    { selling_plan_groups: n } = t,
    { selling_plan_allocations: i } = e;
  if (
    (n.map((o) => {
      if (Array.isArray(o.selling_plans) && o.selling_plans.length) {
        let l = o.selling_plans[0],
          t = i.find((o) => Number(o.selling_plan_id) === Number(l.id)) || {};
        const { selling_plan_group_id: n, per_delivery_price: r } = t;
        let p = document.querySelector(`#loop-price-${e.id}-${n}`);
        p && (p.innerHTML = loopFormatMoney(r, !0));
      }
    }),
    l && l.selling_plan_group_id)
  ) {
    const { selling_plan_group_id: o, per_delivery_price: t } = l;
    let n = document.querySelector(`#loop-price-${e.id}-${o}`);
    n && (n.innerHTML = loopFormatMoney(t, !0));
  }
  let r = getLoopSubscriptionContainer(o).querySelector("#loop-price-one-time");
  r && (r.innerHTML = loopFormatMoney(e.price, !0));

  if (window.loopProps[o]?.sellingPlan?.price != undefined) {
    let priceLabel = document.querySelector("#priceToShow");
    var priceToShow = window.loopProps[o].sellingPlan.price;
    priceLabel.innerHTML =
      loopFormatMoney(priceToShow, !0) + '<span class="each_text">each</span>';
  }
}

function setupListeners(o) {
  getLoopSubscriptionContainer(o)
    .querySelectorAll(".loop-one-time-purchase-option")
    .forEach((o) => {
      o.addEventListener("click", clickOnSellingPlanGroupContainer);
    });
  getLoopSubscriptionContainer(o)
    .querySelectorAll(".loop-subscription-group")
    .forEach((o) => {
      o.addEventListener("click", clickOnSellingPlanGroupContainer);
    });
  getLoopSubscriptionContainer(o)
    .querySelectorAll("input[name=loop_purchase_option]")
    .forEach((o) => {
      o.addEventListener("click", changeInSellingPlanGroupLoop);
    });
  getLoopSubscriptionContainer(o)
    .querySelectorAll(".loop-selling-plan-selector")
    .forEach((o) => {
      o.addEventListener("change", changeInDeliveryOptionLoop);
    });
}
async function getLoopSettingsData(o) {
  (window.productId = o), console.log(`initializing loop - ${o}`);
  let e = getProductJson(o);
  console.log(e);
  window.loopProps || (window.loopProps = {}),
    e?.selling_plan_groups &&
      Array.isArray(e.selling_plan_groups) &&
      (e.selling_plan_groups = e.selling_plan_groups.filter(
        (o) => "5284869" === o.app_id
      ));
  let l = e.selling_plan_groups.map((o) => o.id);
  (e.variants = e.variants.map((o) => ({
    ...o,
    selling_plan_allocations: o.selling_plan_allocations.filter((o) =>
      l.includes(o.selling_plan_group_id)
    ),
  }))),
    (window.loopProps[e.id] = {
      product: e,
    });
  try {
    let o = {};
    try {
      let e = await fetch(
        `https://d217z8zw4dqir.cloudfront.net/${Shopify.shop}.json`
      );
      o = (await e.json()) || {};
    } catch (o) {
      console.log(o);
    }
    window.loopPropsUI = {
      ...o,
    };
    let l = getLoopSubscriptionContainer(e.id).querySelector(
      "#loop-selling-plan-fieldset"
    );
    l && l.classList.remove("loop-display-none");
    let t = getLoopSubscriptionContainer(e.id).querySelectorAll(
      ".loop-purchase-options-label"
    );
    t &&
      t.forEach((o) => {
        o && o.classList.remove("loop-display-none");
      });
    let n = null;
    const i = document.URL;
    let r = new URL(i).searchParams.get("variant") || "";
    (e?.variants.map((o) => o.id) || []).includes(Number(r)) && (n = r),
      loopInit({
        productId: e.id,
        product: JSON.parse(JSON.stringify(e)),
        variantId: n,
      });
    let p = getLoopSubscriptionContainer(e.id);
    p && p.classList.remove("loop-display-none");
  } catch (o) {
    console.log(o);
  }
  try {
    document.querySelectorAll("form").forEach((o) => {
      let l = o.querySelector('[name="id"]'),
        t = o.querySelector('[name="loop_variant_id"]');
      l && t && l.value && (t.value = l.value);
      let n = e?.variants.map((o) => o.id);
      if (l && l.value && n.includes(Number(l.value))) {
        const n = {
          attributes: !0,
          childList: !0,
          subtree: !0,
        };
        new MutationObserver(function (o, n) {
          let i = l?.value || "";
          i &&
            i !== (t?.value || "") &&
            ((t.value = i),
            variantChanged({
              loopProduct: e,
              variantId: i,
            }));
        }).observe(o, n);
      }
    });
  } catch (o) {
    console.log(o);
  }
}
(arrToInstanceCountObj = (o) =>
  o.reduce((o, e) => ((o[e] = (o[e] || 0) + 1), o), {})),
  (loopPriceSelectors = [
    ".price.price--on-sale .price__sale .price-item--sale",
    ".product-single__prices .product__price:not(.product__price--compare)",
    ".product-pricing .product--price .price--main .money",
    "[data-zp-product-discount-price]",
    ".product-single__header .product__price",
    ".modal_price .current_price",
    ".product-area__col--price .current-price.theme-money",
    '[data-product-type="price"][data-pf-type="ProductPrice"]',
    ".product__price .fs-heading-4-base[data-price]",
    "#product-price .money[data-product-price]",
    "#ProductPrice",
    ".product-single__price",
    ".price:not(.price--on-sale) span.price-item--regular",
    ".product-price .price .money:not(.original)",
    ".price-box #price .price",
    ".product__price span[data-product-price]",
    ".product-form--price-wrapper .product-form--price",
    ".product-page--pricing--variant-price #price-field",
    ".price-reviews .product-price",
  ]);
